export default __webpack_public_path__ + "static/media/_not-saved-post-icon_dark.b90b75cd.svg";